import { useState } from 'react';
import type { UnassignUserRoleRequest, UnassignUserRoleResponse } from 'vopay';
import vopayApi from '@/services/api.config';

const { api } = vopayApi;

/**
 * Direct Pattern hook for removing a Role from a user.
 * Hits POST /account/user-roles/unassign. Returns 404 if the assignment
 * doesn't exist; the caller can treat that as a no-op for multi-select flows.
 */
export default function useUnassignUserRole() {
  const [submitting, setSubmitting] = useState(false);

  async function unassignUserRole(params: UnassignUserRoleRequest, bearer?: string): Promise<UnassignUserRoleResponse> {
    try {
      setSubmitting(true);
      const res = await api.unassignUserRole(params, undefined, bearer);
      if (!res.Success) {
        throw new Error(res.ErrorMessage);
      }
      return res;
    } catch (error) {
      console.error('Unassign user role failed:', error);
      throw error;
    } finally {
      setSubmitting(false);
    }
  }

  return { submitting, unassignUserRole };
}
